import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";


class PaymentCreditCardForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>To remove payment terms for this account, it needs to either have no active subscription or to have a credit card set up (even if invalid).</p>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }

}

const ReduxForm = reduxForm({
  form: "PaymentCreditCardForm"
})(PaymentCreditCardForm);

export default ReduxForm;